import CloseAnswerPanel from 'actions/answers/close_answer_panel';
import CloseCommentPanel from 'actions/task/close_comment_panel';
import { SidePanelType } from 'models/side_panel';

export default class CloseSidePanels {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    this.context.executeAction(CloseCommentPanel);

    const sidePanel = this.context.stores.sidePanel.get();
    if (sidePanel.isShowing(SidePanelType.ANSWER)) {
      this.context.executeAction(CloseAnswerPanel, attrs);
    }
  }
}
